import React, { useState } from "react";
import { Button, Grid, FormControl, InputAdornment, InputLabel, OutlinedInput, CircularProgress } from "@material-ui/core";
import { PollPanelStyle } from "../../../infrastructure/PollPanelStyle";

export const CreateNewResponse = ({ createResponse, ID }) => {
  const classes = PollPanelStyle();
  const [isLoading] = useState(false);
  const [respuesta, setRespuesta] = useState("");
  const [isErrResponse, setIsErrResponse] = useState(false);
  const [messageErr, setMessageErr] = useState("");


  const crear = () => {
    if (respuesta.trim() !== "") {
      const data = {
        question: respuesta,
      };
      createResponse(data);
    } else {
      setIsErrResponse(true);
      setMessageErr("La pregunta no puede estar vacía.");
      setTimeout(() => {
        setIsErrResponse(false);
      }, 3000);
    }
  };

  return (
    <form>
      <Grid container spacing={3} style={{ textAlign: "left" }}>
        <Grid item xs={12} md={12} sm={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="pregunta">Pregunta</InputLabel>
            <OutlinedInput
              id="pregunta"
              type="total"
              name="pregunta"
              value={respuesta}
              onChange={(e) => setRespuesta(e.target.value)}
              startAdornment={
                <InputAdornment position="start">-</InputAdornment>
              }
              labelWidth={100}
              style={{borderRadius:'10px'}}
            />
          </FormControl>
        </Grid>
      </Grid>

      <div className={classes.wrapper}>
        <Grid container justifyContent="center" style={{ marginTop: "10px" }}>
          <Button
            disabled={isLoading}
            type="button"
            variant="contained"
            color="primary"
            style={{ textTransform: "none",width:'60%',borderRadius:'10px'}}
            onClick={crear}
          >
            Crear Nueva Respuesta
          </Button>
        </Grid>
        {isLoading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
        {isErrResponse && (
          <div style={{ color: "red", textAlign: "center", paddingTop: 10 }}>
            {messageErr}
          </div>
        )}
      </div>
    </form>
  );
};
